import type { FeatureKey } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";

/** Fonte única de flags de feature no frontend — substitui os padrões antigos (`isPaidPlan` solto,
 *  `requiresPlan` no nav, prop `plan` passado manualmente). `staleTime: 0` + refetch em foco/mount
 *  reduzem a janela de UI desatualizada depois de um toggle do admin — isso é só UX, a autorização
 *  de verdade é sempre no backend (ver packages/api/src/trpc.ts, featureProcedure). */
export function useFeatureFlags(): Partial<Record<FeatureKey, boolean>> {
  const query = trpc.organization.getFeatureFlags.useQuery(undefined, {
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
  return query.data ?? {};
}

export function useFeature(key: FeatureKey): boolean {
  return useFeatureFlags()[key] ?? false; // fail-closed no cliente também
}
